import { useMergedInbox } from './MergedInboxProvider';
import * as Styled from './MessageDrawer.styled';
import { StyledDrawer } from '../StyledDrawer/StyledDrawer';
import { MessagesList } from './components/MessagesList';
import { filterCurrentOrganizationAndDirectMessages } from '@modules/shared/components/Layout/MessageCenter/organizationMessages';
import { useOrganization } from 'app/_providers/Organization';

import { BellOutlined, CloseOutlined } from '@ant-design/icons';
import { Badge, BadgeLayout } from '@capra/core';
import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

// for some reason Courier returns archived messages without archived flag after we archived the message,
// store messages IDs on UI side and don't show them to the user to avoid flickering
const ARCHIVED_MESSAGES_IDS: string[] = [];

export const MessagesDrawer: React.FC = () => {
  const { organizationId } = useOrganization();

  const [isDrawerOpened, setIsDrawerOpened] = useState<boolean>(false);

  const handleToggleDrawer = (): void => {
    setIsDrawerOpened((prev) => !prev);
  };

  const { messages, fetchMessages, markMessageRead, markMessageArchived } = useMergedInbox();

  useEffect(() => {
    fetchMessages({ params: { limit: 30 } });
  }, [messages?.length]);

  const filteredMessages = filterCurrentOrganizationAndDirectMessages(organizationId, messages).filter(
    (it) => it.preview?.length && it.title?.length && !it.archived && !ARCHIVED_MESSAGES_IDS.includes(it.messageId),
  );

  const handleMarkMessageArchived = async (messageId: string): Promise<void> => {
    ARCHIVED_MESSAGES_IDS.push(messageId);

    await markMessageArchived(messageId);
    await markMessageRead(messageId);
  };

  return (
    <Styled.MessageWrapper>
      <BadgeLayout>
        {filteredMessages.length > 0 && (
          <Badge
            variant='dot'
            appearance='info'
            aria-label='Messages badge'
          />
        )}
        <Tooltip title='Messages'>
          <BellOutlined
            onClick={handleToggleDrawer}
            aria-label='Messages'
            style={{ color: 'rgba(0, 0, 0, 0.45)' }}
          />
        </Tooltip>
      </BadgeLayout>

      <StyledDrawer
        title={
          <>
            Messages
            <CloseOutlined
              onClick={handleToggleDrawer}
              size={12}
            />
          </>
        }
        onClose={handleToggleDrawer}
        open={isDrawerOpened}
        closeIcon={null}
        maskClosable
      >
        <MessagesList
          messages={filteredMessages}
          markMessageArchived={handleMarkMessageArchived}
        />
      </StyledDrawer>
    </Styled.MessageWrapper>
  );
};
